import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import { monthList } from 'views/CompanySetup/companySetupConstants';
import { getMonthName } from './monthName';

export const useYearLabel = (activeTab: string): string => {
  const { organizationData } = useParentOrganizationContext();
  const { startMonth, endMonth } = getMonthName(
    organizationData?.company?.reportingMonth ?? 1
  );

  const endYear =
    startMonth === monthList?.[0]?.label
      ? activeTab?.toString()
      : (Number(activeTab) + 1)?.toString();

  return `${startMonth} ${activeTab} - ${endMonth} ${endYear}`;
};
